import React, { useContext } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';

const DashboardTemp = () => {
    const { companyName, }=useContext(ConfigContext);
    return (
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="">
                {/* <h5 className="mb-4">Dashboard</h5> */}
                <div className=' card py-5 rounded-3 px-3 d-flex justify-content-center align-items-center flex-column'>
                  <h4 >Welcome</h4>
                  <h3 >{companyName}</h3>
              </div>
            </div>
          </div>
      </div>
    </div>
    );
}

export default DashboardTemp;
